import {
  Grid,
  Paper,
  Typography,
  Button, Box, Skeleton
} from '@barracuda-internal/bds-core';

export default function Summary({ target_domain, scrollPage }) {

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h5">Summary</Typography>
      <>
        {/* Top cards */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Paper sx={{ p: 2, minHeight: 120, display: 'flex', flexDirection: 'column', }}>
              <Typography variant="caption" color="text.secondary">
                Security posture score
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                <Typography variant="h2" sx={{ width: '80%', fontWeight: 700, lineHeight: 1 }}>
                  <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
                </Typography>

              </Box>

              {/* helper link */}
              <Box sx={{ mt: 1 }}>
                <Button bdsType={'interactiveSubtle'} onClick={() => scrollPage(4)}>How is this calculated?</Button>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={2}>
            <Paper sx={{ p: 2, minHeight: 120, }}>
              <Typography variant="caption" color="text.secondary">
                Vulnerabilities detected
              </Typography>
              <Typography variant="h5" sx={{ width: '80%', fontWeight: 700, mt: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 2, minHeight: 120, }}>
              <Typography variant="caption" color="text.secondary">
                Target domain
              </Typography>
              <Typography variant="h5" sx={{ width: '80%', fontWeight: 700, mt: 1 }}>
                {target_domain}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={3}>
            <Paper sx={{ p: 2, minHeight: 120, }}>
              <Typography variant="caption" color="text.secondary">
                Scan completed on
              </Typography>
              <Typography variant="h5" sx={{ width: '80%', fontWeight: 700, mt: 1 }}>
                <Skeleton variant="text" sx={{ fontSize: '1.5rem' }} />
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Row: Vulnerabilities by severity (left) and Top risks (right) */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 560 }}>Vulnerabilities by severity</Typography>
                  <Button bdsType={'interactiveSubtle'} onClick={() => scrollPage(1)}>View all ↓</Button>
                </Box>
                {/* removed central square placeholder per request; keep empty flex so column heights match */}
                <Box sx={{ flex: 1 }} />

                <Grid container sx={{ mt: 1, height: '300px', width: '100%', textAlign: 'center' }}>
                  <Skeleton variant="rectangular" width={'80%'} height={250} />
                </Grid>

                {/* <Divider sx={{ my: 1 }} /> */}

                <Grid container sx={{ mt: 1 }}>
                  <Grid item xs={3}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#1976d2' }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          <Skeleton variant="circular" width={25} height={25} />
                        </Typography>
                      </Box>
                      <Typography variant="subtitle2" sx={{ mt: 1, color: '#616161', fontWeight: 700 }}>Severity: high</Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#1e88e5' }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          <Skeleton variant="circular" width={25} height={25} />
                        </Typography>
                      </Box>
                      <Typography variant="subtitle2" sx={{ mt: 1, color: '#616161', fontWeight: 700 }}>Severity: medium</Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#64b5f6' }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          <Skeleton variant="circular" width={25} height={25} />
                        </Typography>
                      </Box>
                      <Typography variant="subtitle2" sx={{ mt: 1, color: '#616161', fontWeight: 700 }}>Severity: low</Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={3}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', backgroundColor: '#bbdefb' }} />
                        <Typography variant="body1" sx={{ fontWeight: 500 }}>
                          <Skeleton variant="circular" width={25} height={25} />
                        </Typography>
                      </Box>
                      <Typography variant="subtitle2" sx={{ mt: 1, color: '#616161', fontWeight: 700 }}>Severity: info</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 560 }}>Top risks</Typography>
                  <Button bdsType={'interactiveSubtle'} onClick={() => scrollPage(1)}>View all ↓</Button>
                </Box>

                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {[1, 2, 3, 4, 5].map((t, i) => (
                    <Box key={i} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1 }}>
                      <Box>
                        <Typography><Skeleton variant="text" width={350} sx={{ fontSize: '1rem' }} /></Typography>
                      </Box>
                      <Box sx={{ textAlign: 'left', minWidth: 140, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'left' }}>
                          <Skeleton variant="text" width={100} sx={{ fontSize: '1rem' }} />
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
                {/* show first/top risk detail below the list */}

                <Box sx={{ mt: 2 }} style={{ justifyContent: 'flex-start' }}>
                  <Typography sx={{ fontWeight: 700 }}>
                    <Skeleton variant="text" width={100} sx={{ fontSize: '1rem' }} />
                  </Typography>

                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }} >
                    <Skeleton variant="text" width={600} sx={{ fontSize: '1rem' }} />
                  </Typography>

                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>


        {/* Attack exposure area */}
        <Box sx={{ mt: 2 }}>
          <Paper sx={{ p: 2, backgroundColor: '#fafafa' }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>Attack exposure</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              <Skeleton variant="rectangular" width={'100%'} height={120} />
            </Typography>

          </Paper>
        </Box>
      </>
    </Box>
  );
}
